import React from "react";
import "./GlassWrapper.css";

export const GlassWrapper = ({ children, className = "" }) => {
  return <div className={`glass-wrapper ${className}`}>{children}</div>;
};

export default GlassWrapper;
